import type {TimelineItem} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {TimelineAuthor} from '../TimelineAuthor'

export function CopilotWorkStartedEventText({item}: {item: TimelineItem}) {
  const info = item.additionalInfo?.info
  const onBehalfOf = info?.case === 'copilotWorkStartedEvent' ? info.value.onBehalfOf : undefined

  return (
    <>
      started reviewing on behalf of{' '}
      <TimelineAuthor avatarUrl={onBehalfOf?.avatarUrl} login={onBehalfOf?.displayLogin} />
    </>
  )
}
